"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultControl = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowIcon_1 = require("../../../ArrowIcon");
const common_1 = require("../../../common");
const constans_1 = require("../helpers/constans");
const renderers_1 = require("./");
const InputBox_1 = require("../../helpers/InputBox");
const Icon_1 = require("../../../Icon");
const icons_1 = require("../../../icons");
const StyledInputBox = (0, styled_components_1.default)(InputBox_1.InputBox) `
    min-width: ${constans_1.MIN_WIDTH_COMBOBOX};
`;
function createDefaultControl({ buildIn, formatText = ({ text }) => text, iconGetter, renderValue = renderers_1.defaultValueRenderer, hasClear = false } = {}) {
    return function defaultControlRenderer(_a) {
        var { className, control, error, placeholder, disabled, size, active, actions, opened, focused, value, hasEnterKeyStopPropagation, text, onClear, option, testId, searchTerm, onSearchTermChange, style } = _a, rest = __rest(_a, ["className", "control", "error", "placeholder", "disabled", "size", "active", "actions", "opened", "focused", "value", "hasEnterKeyStopPropagation", "text", "onClear", "option", "testId", "searchTerm", "onSearchTermChange", "style"]);
        const formattedText = formatText({ text, value, option });
        const icon = iconGetter === null || iconGetter === void 0 ? void 0 : iconGetter({ option, value });
        return (react_1.default.createElement(StyledInputBox, Object.assign({}, rest, { "data-selector-id": testId, className: className, hasError: error, isDisabled: disabled, size: size, rows: 1, highlighted: opened && buildIn, actions: [
                hasClear &&
                    !!text && {
                    testId: 'clear-control',
                    icon: react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.ClearIcon, { error: error, disabled: disabled }) }),
                    onClick: onClear
                },
                {
                    icon: react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: common_1.ARROW_DIRECTION.down }),
                    active: opened,
                    onMouseDown: () => {
                        opened ? actions.close() : actions.open();
                    }
                }
            ], isActive: opened || active, isFocused: focused, buildIn: buildIn, onBlur: control.onBlur, onFocus: control.onFocus, onClick: control.onClick, onMouseDown: control.onMouseDown, onMouseUp: control.onMouseUp, onMouseEnter: control.onMouseEnter, onMouseLeave: control.onMouseLeave, onKeyDown: control.onKeyDown, onKeyUp: control.onKeyUp, onKeyPress: control.onKeyPress, ref: control.ref, style: control.style }), renderValue({
            icon,
            disabled,
            placeholder,
            formattedText,
            value,
            option,
            text
        })));
    };
}
exports.createDefaultControl = createDefaultControl;
//# sourceMappingURL=defaultControlRenderer.js.map